// GA4 + Meta Pixel — env-driven, no-ops when IDs are absent
const GA4_ID = process.env.REACT_APP_GA4_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialised = false;

export function initAnalytics() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: true });
  }
  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

const PIXEL_MAP = {
  assessment_started: "StartTrial",
  assessment_completed: "CompleteRegistration",
  payment_initiated: "InitiateCheckout",
  payment_success: "Purchase",
  premium_purchase: "Purchase",
  report_download: "ViewContent",
};

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", event, params);
  if (window.fbq) {
    const std = PIXEL_MAP[event];
    if (std) window.fbq("track", std, { currency: "INR", ...params });
    else window.fbq("trackCustom", event, params);
  }
}

export function pageView(path) {
  if (typeof window === "undefined") return;
  if (window.gtag && GA4_ID) window.gtag("event", "page_view", { page_path: path });
  if (window.fbq) window.fbq("track", "PageView");
}
